// Mirrors Framework.Core.DTO.Enums.BusinessSystem in NHA.Backend.
export enum BusinessSystem {
	MyNHA = 1,
	Scholar = 2
}
